export const TURNOVERREPORTLIST_SEARCH = 'TURNOVERREPORTLIST_SEARCH';
export const TURNOVERREPORTLIST_PAGE = 'TURNOVERREPORTLIST_PAGE';
export const TURNOVERREPORTLIST_STARTDATE = 'TURNOVERREPORTLIST_STARTDATE';
export const TURNOVERREPORTLIST_ENDDATE = 'TURNOVERREPORTLIST_ENDDATE';
export const TURNOVERREPORTLIST_ACTIVITYLABELID = 'TURNOVERREPORTLIST_ACTIVITYLABELID';
